export default {
  // Hero
  "home.hero.title_line1": "Federation of",
  "home.hero.title_line2": "Black Sea Fishermen's",
  "home.hero.title_line3": "Organizations",
  "home.hero.title_line_de": "Fishermen's Organizations",
  "home.hero.title_line_full": "of the Black Sea",
  "home.hero.title_line1_full": "Federation of Black Sea Fishermen's",
  "home.hero.title_line2_full": "Organizations",
  "home.hero.subtitle_line1": "The unified voice of commercial fishing in the Black Sea.",
  "home.hero.subtitle_line2": "Protecting tradition, regulating the future.",
  "home.hero.cta": "Join the Federation",

  // Stats
  "home.stats.founded": "Year Founded",
  "home.stats.members": "Members",
  "home.stats.fishermen": "Fishermen Represented",
  "home.stats.tons": "tons",

  // About / President
  "home.about.label": "A message from",
  "home.about.title": "The FOPMN President",
  "home.about.quote1": "Throughout all these years, marked by numerous challenges for the fisheries sector—including continuous legislative changes and financial, logistical, and workforce shortages—I have remained on the front line, firmly representing the interests of small-scale fishers before public authorities and the media, supporting the sector's development and promoting the sustainable management of fishery resources.",
  "home.about.quote2": "The sector's greatest asset is its professional fishers—the men and women whose knowledge, experience, and dedication to their craft keep this traditional occupation alive while providing Romanian consumers with high-quality Romanian fish products.",
  "home.about.name": "Laurențiu Mirea",
  "home.about.role": "FOPMN President",

  // Gallery Teaser (Home page — Coverflow 3D)
  "home.gallery_teaser.label": "From the Field",
  "home.gallery_teaser.title": "FOPMN Fishermen in Action",
  "home.gallery_teaser.description": "Discover our complete gallery with videos and images from the daily work of professional Black Sea fishermen. You will find authentic footage from the sea, the port, and landing points.",
  "home.gallery_teaser.cta": "View full gallery",

  // News
  "home.news.label": "Latest Updates",
  "home.news.title": "News",
  "home.news.all": "All News",
  "home.news.read_more": "Read more",
  "home.news.find_more": "Find out more",

  // Featured Cards
  "home.cards.fishing": "Romanian Fishing",
  "home.cards.fishermen": "Professional Fishermen",
  "home.cards.gastronomy": "Promoting Seafood Gastronomy",

  // Sponsor
  "home.sponsor.title": "Support Professional Black Sea Fishing",
  "home.sponsor.description": "Your support helps us remain a unified and powerful voice, capable of defending the rights of professional fishermen, supporting negotiations on annual fishing quotas, and protecting the future of the Black Sea fishing sector.",
  "home.sponsor.cta": "Sponsor",
};